import * as Yup from 'yup';

import {
  globalMessages,
  isEmail,
  isValidPhoneNumber,
} from '@savgroup-front-common/core/helpers';

import messages from './messages';

const claimGroupConfirmationSchema = Yup.object().shape({
  phone: Yup.string()
    .required(globalMessages.form.required)
    .test('validPhoneNumber', messages.phoneFormatError, (value, context) => {
      const { phoneCountryCode } = context.parent;

      if (!phoneCountryCode) {
        return false;
      }

      return value ? isValidPhoneNumber(value, phoneCountryCode) : true;
    }),
  email: Yup.string()
    .required(globalMessages.form.required)
    .test('is-email', globalMessages.form.invalidEmail, (value) => {
      return isEmail(value);
    }),
  cgv: Yup.bool()
    .oneOf([true], globalMessages.form.required)
    .required(globalMessages.form.required),
});

export default claimGroupConfirmationSchema;
